export default __webpack_public_path__ + "img/paste-new.db6b7625.svg";